import React, { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'

const SearchTeacherByCi = ({ searchDocenteByCi, setTeachers, isLoading, getTeachers }) => {
    const [ciDocente, setCiDocente] = useState('')

    const handleSearchTeacher = () => {
        if (ciDocente) {
            searchDocenteByCi(ciDocente)
        } else {
            handleClearSearch()
        }
    }

    const handleClearSearch = () => {
        getTeachers()
        ciDocente && setCiDocente('')
    }

    return (
        <div className='contenedor input-search-docente'>
            <input
                value={ciDocente}
                placeholder='Buscar docente por CI'
                onChange={(e) => setCiDocente(e.target.value.toUpperCase())}
                onKeyUp={(e) => e.key === 'Enter' && handleSearchTeacher()}
            />
            <Button variant='blue' style={{ width: '5.05rem' }} onClick={() => handleSearchTeacher()}>
                {isLoading ? <Spinner variant='light' size='sm' /> : 'Buscar'}
            </Button>
            <Button variant='danger' style={{ width: '5.05rem' }} onClick={handleClearSearch}>
                Limpiar
            </Button>
        </div>
    )
}

export default SearchTeacherByCi
